import { SurveyQuestion, SelectionStats, Survey } from "../../DTOs";
import { getThemeQuestionIndices, surveyReportHelper } from "../../helpers";
import { QuestionStats } from "./QuestionStats";

export type ThemeQuestionData = {
    themeIndex:number,
    themeTitle:string,
    themeQuestionIndex:number,
    surveyQuestionIndex:number,
    surveyQuestion:SurveyQuestion,
    questionReport:QuestionStats
}

export type ThemeReportData = {
    themeIndex:number,
    theme:string,
    selections:SelectionStats,
    questionData:ThemeQuestionData[]
};

export class ThemeReport
{
    public data:ThemeReportData[];

    constructor(
        survey:Survey,
        questionReports:QuestionStats[]
    ){
        this.data = [];

        let surveyQuestionIndex = 0;
        for(let themeIndex=0; themeIndex<survey.themes.length; themeIndex++){
            const theme = survey.themes[themeIndex];

            let selections = new SelectionStats(surveyReportHelper.createNewSelectionSummary());
            const questionData:ThemeQuestionData[] = [];
            
            const {start} = getThemeQuestionIndices(survey, theme.name);
            
            for(let themeQuestionIndex = 0; themeQuestionIndex <theme.questions.length; themeQuestionIndex++){
                const surveyQuestion = theme.questions[themeQuestionIndex];
                const questionReport = questionReports[start + themeQuestionIndex];
                
                selections =
                    SelectionStats.aggregate(
                        selections.data, 
                        questionReport.selections.data
                    );
                
                questionData.push({
                    themeIndex,
                    themeTitle: theme.name,
                    themeQuestionIndex,
                    surveyQuestionIndex,
                    surveyQuestion, 
                    questionReport
                })
                surveyQuestionIndex++;
            }

            this.data.push(
                {
                    themeIndex,
                    theme: theme.name, 
                    selections,
                    questionData
                }
            );
        }
    }
}




